import { Navigate, Outlet, useLocation } from 'react-router';

import { Button } from '../components/ui/button.tsx';
import { Loading } from '../components/ui/skeleton.tsx';
import { errorMessage } from '../lib/api.ts';
import { useSession } from '../lib/session.ts';

/**
 * Pages that need a complete session. Without one, go to the login and come back
 * afterwards (?volver=); with 2FA pending, go to the 2FA step.
 */
export function RequireSession() {
  const { data: session, isPending, error, refetch } = useSession();
  const location = useLocation();

  if (isPending) return <Loading label="Cargando tu sesión…" />;
  if (error) {
    return (
      <div role="alert" className="mx-auto max-w-md space-y-4 p-6 text-center">
        <p>{errorMessage(error)}</p>
        <Button onClick={() => void refetch()}>Reintentar</Button>
      </div>
    );
  }
  if (!session) {
    const back = `${location.pathname}${location.search}`;
    const query = back !== '/' ? `?volver=${encodeURIComponent(back)}` : '';
    return <Navigate to={`/iniciar-sesion${query}`} replace />;
  }
  if (session.mfa !== 'verified') return <Navigate to="/verificacion" replace />;
  return <Outlet />;
}
